import React, { Component } from 'react';
import { connect } from 'react-redux';
import timeHelpers from '../utils/timeHelpers.js';
import shared from '../utils/shared.js';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import { getFileType, videoType } from '../utils/shared';
import { logToServer } from '../actions/display';
// import { combinePathFile } from '../utils/dataHelpers';
import _ from 'lodash';

window.tmpLogArray = [];
const _videoStyle = {
  preload: 'auto',
  position: 'fixed',
  minWidth: '100%',
  minHeight: '100%',
  width: '100%',
  height: '100%',
  zIndex: -100,
  loop: '',
  autoplay: "",
  muted: "",
  pointerEvents: "none"
}

class VerticalVideoSync extends Component {

  constructor(props) {
    super(props);
    this._currentWordScreen = 1;
    this._wordIndex = 0;
    this._slidesWords = [];
    this._slideshowConfig = {}

    this._screenWords = {
      initialDelay: 3,
      stayTime: 2,
      delayBetweenWords: .5,
      screens: 5,
      topOffset: .05 * (this.props.screen.screenHeight / 5)
    }
    this._cycleIntervals = [];
    this._elementStates = [];
    this.setupElements();
    let elementIndex = timeHelpers.indexFromIntervalArray(this._cycleIntervals);
    let currentTimeInterval = timeHelpers.currentSeekTimeArray(this._cycleIntervals);

    let contentStage = 0;
    if (elementIndex === (this._elementStates.length - 1)) {
      contentStage = 1;
    }

    this.state = {
      elementIndex: elementIndex,
      wordIndex: 0,
      showDebug: 0,
      currentTimeInterval: currentTimeInterval,
      currentWordScreen: 1,
      showWord: false,
      wordFadeStep: 3, //0 fade in, 1 stay in, 2 fade out, 3 stay out,
      contentStage: contentStage
    };
    this._intervalTimeout = null;
    this._intervalSeekTimeout = null;
    this._wordsIntervalTimeout = null;
    this._currentVideoRef = null;
    this._intervalTimeoutMS = timeHelpers.timeIntervalRemainderArrayMS(this._cycleIntervals, true);
    this._wordsIntervalTimeoutMS = 0; //run right away for first call

  }

  componentDidMount() {
    this.props.logToServer([new Date() + " Component just mounted"], "VerticalVideoSync", this.props.content.id, this.props.screen.mode, this.props.screen.webkey);
    this.setupIntervalHandler();
    document.addEventListener("keydown", this.handleKeyDown);
    this.setVideoSeekTimeInterval();

    // this.setupWordsInterval();

  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    clearTimeout(this._intervalTimeout);
    this._intervalTimeout = null;
  }

  handleKeyDown = (event) => {
    switch (event.key) {
      case "s":
        console.log(this.props);
        break;
      case "m": //testing remove
        //setupWordsInterval after delay
        // clearTimeout(this._wordsInvervalTimeout);
        // this._wordsInvervalTimeout = null;
        // this._wordsInvervalTimeout = setTimeout(() => {
        //     this.setupWordsInterval();
        // }, this._screenWords.initialDelay*1000);
        // //loop the index
        // let elementIndex = shared.loopIndex(this.state.elementIndex, 0, this._elementStates.length - 1, "forward");

        // this.setState({
        //   elementIndex: elementIndex
        // })
        // this.setupIntervalHandler();
        break;
      default:
        break;
    }
  }

  setupElements() {

    let slides = [];
    // let slideshowId = null;

    let dm = this.props.content.dm_active[this.props.active_module];

    if (!dm) {
      console.log("No slide module found with the given name, check the name= url parameter.");
    }

    this._wordStyle = {
      position: 'absolute',
      left: this.props.screen.screenWidth * 0.1,
      width: this.props.screen.screenWidth * .8,
      color: '#ffffff',
      fontSize: this.props.screen.screenHeight * 0.037037037,
      fontStyle: 'Normal',
      fontWeight: 400,
      textAlign: 'left',
      lineHeight: 1,
      visible: true
    }

    let customWordStyle = _.get(dm, 'contents.custom_fields.inspirationalWordsStyling', null);
    // console.log("CUSTOM WORD STYLE?", customWordStyle);
    if (customWordStyle !== null) {
      this._wordStyle.fontSize = customWordStyle.fontSize * .01 * this.props.screen.screenHeight
      this._wordStyle.fontStyle = customWordStyle.fontStyle;
      this._wordStyle.fontFamily = customWordStyle.font;
      this._wordStyle.fontWeight = Number(customWordStyle.fontWeight);
      this._wordStyle.textAlign = customWordStyle.justification.toLowerCase();
      this._wordStyle.lineHeight = customWordStyle.lineHeight * .01;
      this._wordStyle.visible = customWordStyle.visible;
      this._screenWords.topOffset = customWordStyle.height * (this.props.screen.screenHeight / 5) * .01;
    }

    this._slideshowConfig = dm.contents;
    _.forEach(dm.contents.images, (img, imgKey) => {
      if (_.get(dm, 'contents.bool0s[' + imgKey + ']', true) === true && (imgKey % 2 === 0)) {
        let textColor = _.get(dm, 'contents.color0s[' + imgKey + ']', "#000000");
        slides.push({
          "backgroundContent": img,
          "attributeText": dm.contents.names[imgKey],
          "showWords": _.get(dm, 'contents.bool1s[' + imgKey + ']', false),
          "textColor": textColor
        })
        this._cycleIntervals.push(_.get(dm, 'contents.cycle_overrides[' + imgKey + ']', 5) * 1000);
      }
    });

    if (_.has(dm.contents, "custom_fields.words.val") && dm.contents.custom_fields.words.val.length > 0) {
      this._slidesWords = dm.contents.custom_fields.words.val.split(",");
    }
    // console.log("slides", slides);
    // console.log(this._cycleIntervals, this._cycleIntervals)
    // let slideshow = _.find(this.props.content.dm_active, function(o) { return o.id === Number(slideshowId) });
    this._elementStates = slides;
    if (this._elementStates.length === 0){
      console.log("no slides detected, please add a slideshow and confirm the slides are set to active.");
    }
  }

  setVideoSeekTimeInterval = () => {
    clearTimeout(this._intervalSeekTimeout);
    this._intervalSeekTimeout = null;
    this._intervalSeekTimeout = setTimeout(() => {
      let fileType = getFileType(this._elementStates[this.state.elementIndex].backgroundContent.file_name);
      if (fileType === "video") {
        if (!this._currentVideoRef) {
          this.setVideoSeekTimeInterval();
        } else {
          // Set the current position in which the video should be.
          this._currentVideoRef.currentTime = (this.state.currentTimeInterval / 1000);
          clearTimeout(this._intervalSeekTimeout);
        }
      }
    }, 30);
  }

  setupWordsInterval = () => {
    let endCycle = false;
    switch (this.state.wordFadeStep) {
      case 0: //fade in
        this._wordsIntervalTimeoutMS = 300;
        this.setState({
          showWord: true,
          currentWordScreen: this._currentWordScreen,
          wordFadeStep: 1,
          wordIndex: this._wordIndex
        });
        break;
      case 1: //stay in
        this._wordsIntervalTimeoutMS = this._screenWords.stayTime * 1000;
        this.setState({
          wordFadeStep: 2
        });
        break;
      case 2: //fade out
        this._wordsIntervalTimeoutMS = 300;
        this.setState({
          showWord: false,
          wordFadeStep: 3
        });
        break;
      case 3: //stay out
        this._wordsIntervalTimeoutMS = this._screenWords.delayBetweenWords * 1000;
        this._wordIndex = shared.loopIndex(this._wordIndex, 0, this._slidesWords.length - 1, "forward");
        if (this._currentWordScreen === this._screenWords.screens) {
          endCycle = true;
          this._currentWordScreen = 1;
        } else {
          this._currentWordScreen++;
        }
        this.setState({
          wordFadeStep: 0
        });
        break;
      default:
        break;
    }
    clearTimeout(this._wordsInvervalTimeout);
    this._wordsInvervalTimeout = null;
    this._wordsInvervalTimeout = setTimeout(() => {
      if (endCycle !== true) {
        this.setupWordsInterval();
      }
    }, this._wordsIntervalTimeoutMS);
  }

  // Setup the interval handler that will loop through the background
  // every {elementInterval} amount of time and through every element
  // in this._elementStates

  setupIntervalHandler = () => {
    window.tmpLogArray.push(new Date() + " Creating Timeout");
    window.tmpLogArray.push(new Date() + " Current index is: " + this.state.elementIndex);
    clearTimeout(this._intervalTimeout);
    this._intervalTimeout = null;
    this._intervalTimeout = setTimeout(() => {
      this._intervalTimeoutMS = timeHelpers.timeIntervalRemainderArrayMS(this._cycleIntervals, true);
      window.tmpLogArray.push(new Date() + " Time for the next Cycle: " + this._intervalTimeoutMS);

      //handle moment of calculation resulting in a near 0 number and multiple cycles
      if (this._intervalTimeoutMS > 500) {
        //loop the index
        let elementIndex = shared.loopIndex(this.state.elementIndex, 0, this._elementStates.length - 1, "forward");
        // console.log("ELEMENT", this._elementStates[elementIndex]);
        //setupWordsInterval after delay if over the first video
        if (this._elementStates[elementIndex].showWords === true) {
          clearTimeout(this._wordsInvervalTimeout);
          this._wordsInvervalTimeout = null;
          this._wordsInvervalTimeout = setTimeout(() => {
            this.setupWordsInterval();
          }, this._screenWords.initialDelay * 1000);
        }

        let contentStage = 0;
        if (elementIndex === (this._elementStates.length - 1)) {
          contentStage = 1;
        }
        
        window.tmpLogArray.push(new Date() + " Next element Index: " + elementIndex);
        console.log("log to server");
        this.props.logToServer(window.tmpLogArray, 'VerticalVideoSync', this.props.content.id, this.props.screen.mode, this.props.screen.webkey);
        window.tmpLogArray = [];
        
        this.setState({
          elementIndex: elementIndex,
          contentStage: contentStage
        })
        // console.log("A1 this._intervalTimeoutMS: " + this._intervalTimeoutMS, "elementIndex: " + elementIndex, new Date().toTimeString().split(' ')[0]);
      }

      this.setupIntervalHandler();
    }, this._intervalTimeoutMS);
  }

  render() {
    let fileType = getFileType(this._elementStates[this.state.elementIndex].backgroundContent.file_name);
    let cSource = shared.dp(this.props.screen, this._elementStates[this.state.elementIndex].backgroundContent);//combinePathFile(this._elementStates[this.state.elementIndex].backgroundContent);
    let cType = "";
    let content = "";
    // Check if the background is a video or an image.
    if (fileType === "video") {
      cType = videoType(this._elementStates[this.state.elementIndex].backgroundContent.file_name);
      content = <div className="vid" style={{ position: 'absolute', top: 0, left: 0 }}>
        <video style={_videoStyle} id="background-video" loop autoPlay muted ref={el => this._currentVideoRef = el}>
          <source src={cSource} type={cType} />
          Your browser does not support the video tag.
        </video>
      </div>;
    } else {
      // Verify if the image has an attribute text that needs to be shown at the bottom
      let attributeTextStyle = {
        position: 'absolute',
        bottom: this.props.screen.screenHeight * 0.018518519,
        fontSize: this.props.screen.screenHeight * 0.018518519,
        right: this.props.screen.screenWidth * 0.052083333,
        color: 'white',
        fontStyle: 'italic'
      }

      content = <div style={{ width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, position: 'absolute', backgroundSize: "100% 100%", backgroundImage: "url(" + cSource + ")" }} />

      if (this._elementStates[this.state.elementIndex].showAttributeText) {
        content = (
          <div style={{ width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, position: 'absolute', backgroundSize: "100% 100%", backgroundImage: "url(" + cSource + ")" }}>
            <span style={{ ...attributeTextStyle }}>{this._elementStates[this.state.elementIndex].attributeText}</span>
          </div>
        )
      }
    }
    let opacity = Number(_.get(this._slideshowConfig.custom_fields, 'overlay_opacity_vertical.val', 0));
    let overlayCss = {
      backgroundColor: _.get(this._slideshowConfig.custom_fields, 'overlay_color_vertical.val', '#FFFFFF'),
      opacity: opacity !== 0 ? opacity / 100 : opacity,
      position: 'absolute',
      width: this.props.screen.screenWidth,
      height: this.props.screen.screenHeight
    }

    //set top
    //if (this._wordStyle.visible === true) {
    let screenHeight = this.props.screen.screenHeight / this._screenWords.screens;

    let top = screenHeight * (this.state.currentWordScreen - 1) + this._screenWords.topOffset;

    this._wordStyle.color = this._wordStyle.color = this._elementStates[this.state.elementIndex].textColor;
    //  let top = ((screenHeight * this.state.currentWordScreen) - screenHeight) + (screenHeight * .2);
    //}

    // Check if Words on Screen setting is enabled.
    // let wordStyle = {};
    // if (this._wordStyle.visible === true) {
    //   let screenHeight = this.props.screen.screenHeight / this._screenWords.screens;
    //   wordStyle = {
    //     position: 'absolute',
    //     top: ((screenHeight * this.state.currentWordScreen) - screenHeight) + (screenHeight * .2),
    //     left: this.props.screen.screenWidth * 0.1,
    //     fontSize: this.props.screen.screenHeight * 0.037037037
    //   }
    // }
    // console.log("WORD STYLE", this._wordStyle);
    // console.log("TOP", top);
    //console.log("WORD?", this._slidesWords[this.state.wordIndex]);
    return (
      <div>
        <div style={{ position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight }}>
          <CSSTransitionGroup
            component='div'
            transitionName='slowfadedelay'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.elementIndex}>
              {content}
            </div>
          </CSSTransitionGroup>

          <CSSTransitionGroup
            component='div'
            transitionName='slowfadedelay'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.contentStage}>
              {
                this.state.contentStage === 0 ?
                  <div style={overlayCss}></div> : null
              }
            </div>
          </CSSTransitionGroup>
        </div>
        <div style={{ ...this._wordStyle, top: top }}>
          <CSSTransitionGroup
            component='div'
            transitionName='example'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <span key={this.state.showWord}>
              {this.state.showWord ?
                this._slidesWords[this.state.wordIndex]
                : null
              }
            </span>
          </CSSTransitionGroup>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  let elementStateOverride = shared.parseStringParam(window.location.href, "vid");
  let donorSeaName = shared.parseStringParam(window.location.href, "name");

  let returnObj = {
    content: state.content,
    donors: state.donors,
    screen: state.screen,
    active_module: state.active_module
  }
  if (elementStateOverride) {
    returnObj.elementStateOverride = Number(elementStateOverride)
  }
  if (donorSeaName) {
    returnObj.donorSeaName = donorSeaName;
  }
  return returnObj;
};

const mapDispatchToProps = (dispatch) => {
  return {
    logToServer: (logs, type, display, mode, webkey) => dispatch(logToServer(logs, type, display, mode, webkey))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VerticalVideoSync);



// WEBPACK FOOTER //
// ./src/containers/VerticalVideoSync.js